<template>
  <div>
    <v-simple-table v-if="inspection">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">Mot clé</th>
          <th class="text-left">Datacenter</th>
          <th class="text-left">Analyse</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="entry in inspection" :key="entry.id" :class="getBackgroundColor(entry)">
          <td>{{ entry.keyword }}</td>
          <td>{{ entry.datacenter }}</td>
          <td>
            <v-icon v-if="entry.status === 'WORKING'" color="primary">mdi-loading mdi-spin mdi-anim-1s</v-icon>
            <div v-else-if="entry.status === 'FAILED'" class="red--text">
              <v-icon color="error">mdi-alert-circle-outline</v-icon>
              Erreur de traitement
            </div>
            <div v-else>
              <v-chip
                class="mr-1"
                :color="item.count > 1 ? 'primary' : ''"
                small v-for="item in getSortedItems(entry.items)"
                :key="item.name">{{ item.name }} ({{ item.count }})
              </v-chip>
            </div>
          </td>
          <td>
            <v-btn
              small
              icon
              color="primary"
              :disabled="entry.items === null"
              @click="handleClick(entry)"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'CrawlerInspectionTable',
  props: ['hash'],
  data () {
    return {
      objects: this.$carrier.collection()
    }
  },
  watch: {
    hash () {
      this.objects.sync({
        inspection: 'crawler/inspection/' + this.hash + '.json'
      })
    }
  },
  computed: {
    inspection () {
      return this.objects.find('inspection')
    }
  },
  methods: {
    getBackgroundColor (entry) {
      if (entry.status === 'SUCCESS') return 'green lighten-5'
      else if (entry.status === 'SUCCESS') return 'red lighten-5'
      else return ''
    },
    getSortedItems (found) {
      const items = []

      for (const [name, count] of Object.entries(found)) {
        items.push({ name, count })
      }

      return items.sort((a, b) => b.count - a.count)
    },
    handleClick (entry) {
      this.$ui.openDialog('serp_detail', { hash: this.hash, id: entry.id })
    }
  }
}
</script>

<style scoped>

</style>